module.exports = __webpack_public_path__ + "static/img/iStock-881621234_mod.bdc5f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iStock-881621234_mod.png
// module id = 1718
// module chunks = 5